module.exports = __webpack_public_path__ + "static/media/Global User ETAS 2.0 Manual.289a981b.pdf";